import React from 'react'

export const HelpIcon = () => (
  <svg viewBox='0 0 32 32'>
    <path d='M16 27c6.075 0 11-4.925 11-11S22.075 5 16 5 5 9.925 5 16s4.925 11 11 11zm0 2C8.82 29 3 23.18 3 16S8.82 3 16 3s13 5.82 13 13-5.82 13-13 13zm1.086-12.496v1.046c0 1.445-2.166 1.445-2.166 0v-1.984c0-.598.485-1.083 1.083-1.083 1.21 0 2.164-.891 2.164-1.95 0-1.06-.954-1.95-2.164-1.95-1.214 0-2.17.89-2.17 1.95a1.083 1.083 0 1 1-2.166 0c0-2.29 1.957-4.117 4.336-4.117 2.375 0 4.33 1.828 4.33 4.117 0 1.927-1.392 3.513-3.247 3.97zM16 22.5a1.083 1.083 0 1 1 0-2.167 1.083 1.083 0 0 1 0 2.167z' />
  </svg>
)
